import * as React from 'react';
import { compose } from 'recompose';
import b_ from 'b_';
import translate, { InjectedTranslateProps } from '../../utils/translate';
import Link from './components/Link';

import './index.scss';

interface Props {
  size: 'big' | 'small';
}

type Enhanced = Props & InjectedTranslateProps;

const b = b_.with('social-buttons');

const enhance = compose<Enhanced, Props>(translate);

class SocialButtons extends React.Component<Enhanced> {
  render() {
    const { t, size } = this.props;

    return (
      <div className={b({ size })}>
        <Link
          to="https://www.youtube.com/user/theunitedtraders"
          size={size}
          type="youtube"
          text="YouTube"
        />
        <Link to="https://twitter.com/UnitedTraders_1" size={size} type="twitter" text="Twitter" />
        <Link to={t('telegram social link')} size={size} type="telegram" text="Telegram" />
      </div>
    );
  }
}

export default enhance(SocialButtons);
